import { useState, useEffect } from 'react';
import Button from "../../../../components/button/button.jsx";

// O ag-Grid passa todas as propriedades (incluindo value e handleOpen) num objeto só
const CachedImageButton = ({ value, handleOpen }) => {
  const [isCached, setIsCached] = useState(false);

  useEffect(() => {
    const checkCache = async () => {
      if (!value) return;

      let fetchUrl = value;
      if (import.meta.env.DEV) fetchUrl = fetchUrl.replace("/keeper", "/keeperProxy");

      const absoluteUrl = new URL(fetchUrl, window.location.origin).href;

      try {
        const cache = await caches.open('sentry-image-cache');
        const cachedResponse = await cache.match(absoluteUrl) || await cache.match(fetchUrl);

        if (cachedResponse) setIsCached(true);
      } catch (error) {
        console.error("Erro ao verificar o cache da célula:", error);
      }
    };

    checkCache();
  }, [value]);

  return (
    <div className="flex h-full w-full justify-center items-center">
      <Button
        onClick={() => {
          handleOpen(value);
          setIsCached(true);
        }}
        target={isCached ? "primary" : "primary-outline"}
      >
        Solicitar imagem
      </Button>
    </div>
  );
};

export default CachedImageButton;